import { observer } from 'mobx-react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { RecurringTypes } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import {
  CaseColumnNames,
  CaseFilterIds,
} from '@new/domains/operations/screens/CasesV2/utils/config'

import { CheckBoxOption, CheckBoxWrapper } from './commonFilterStyles.style'

const options = [
  {
    value: RecurringTypes.recurring,
    label: <CheckBoxOption>Recurring</CheckBoxOption>,
    hasFullWidth: true,
  },
  {
    value: RecurringTypes.notRecurring,
    label: <CheckBoxOption>Not Recurring</CheckBoxOption>,
    hasFullWidth: true,
  },
]

const _RecurringFilter = () => {
  const { setFilterValue, recurring } = casesFiltersStore

  const handleDataFilter = (value?: string[] | undefined) => {
    setFilterValue(CaseFilterIds.Recurring, value)
  }

  return (
    <CheckBoxWrapper>
      <CheckboxBasedFilter
        title={CaseColumnNames.Recurring}
        options={options}
        initialValue={recurring}
        onChange={handleDataFilter}
      />
    </CheckBoxWrapper>
  )
}

export const RecurringFilter = observer(_RecurringFilter)
